// Central date/time formatting — always render stored UTC timestamps in
// India Standard Time (IST / Asia/Kolkata), regardless of the viewer's location.
const IST = "Asia/Kolkata";

const parse = (v) => {
  if (!v) return null;
  // Bare "YYYY-MM-DD" → treat as date-only (no TZ shift).
  const s = typeof v === "string" ? v : null;
  const d = v instanceof Date ? v : new Date(s && !s.includes("T") ? `${s}T00:00:00Z` : v);
  return Number.isNaN(d.getTime()) ? null : d;
};

// "15 Jul 2026, 5:29 pm"
export function fmtDateTime(v, fallback = "—") {
  const d = parse(v);
  if (!d) return fallback;
  return d.toLocaleString("en-IN", {
    timeZone: IST, day: "2-digit", month: "short", year: "numeric",
    hour: "numeric", minute: "2-digit", hour12: true,
  });
}

// "15 Jul 2026"
export function fmtDate(v, fallback = "—") {
  const d = parse(v);
  if (!d) return fallback;
  return d.toLocaleDateString("en-IN", {
    timeZone: IST, day: "2-digit", month: "short", year: "numeric",
  });
}

// IST has a fixed +05:30 offset (no DST).
const IST_OFFSET_MIN = 330;

// UTC ISO / Date → "YYYY-MM-DDTHH:MM" IST wall-clock, for <input type="datetime-local">.
export function toISTInputValue(v) {
  const d = parse(v);
  if (!d) return "";
  const ist = new Date(d.getTime() + IST_OFFSET_MIN * 60000);
  const p = (n) => String(n).padStart(2, "0");
  return `${ist.getUTCFullYear()}-${p(ist.getUTCMonth() + 1)}-${p(ist.getUTCDate())}T${p(ist.getUTCHours())}:${p(ist.getUTCMinutes())}`;
}

// "YYYY-MM-DDTHH:MM" IST wall-clock → UTC ISO ("...+00:00").
export function istInputToUTC(val) {
  if (!val) return null;
  const [datePart, timePart] = val.split("T");
  const [y, mo, da] = datePart.split("-").map(Number);
  const [h, mi] = (timePart || "00:00").split(":").map(Number);
  const utcMs = Date.UTC(y, mo - 1, da, h, mi) - IST_OFFSET_MIN * 60000;
  return new Date(utcMs).toISOString().replace("Z", "+00:00");
}
